import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createRespondentCounselAPI,
  updateRespondentCounselAPI,
  deleteRespondentCounselAPI,
  getRespondentCounselByCaseIDAPI,
  deleteRespondentCounselDocumentAPI,
} from "../../../api/respondentCounsel_api";

// ============================================================================
// ASYNC THUNKS
// ============================================================================

export const getRespondentCounselByCaseIDAction = createAsyncThunk(
  "respondentCounsel/getRespondentCounselByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getRespondentCounselByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createRespondentCounselAction = createAsyncThunk(
  "respondentCounsel/createRespondentCounsel",
  async (respondentCounselData, { rejectWithValue }) => {
    const response = await createRespondentCounselAPI(respondentCounselData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateRespondentCounselAction = createAsyncThunk(
  "respondentCounsel/updateRespondentCounsel",
  async (
    { respondentCounselID, respondentCounselData },
    { rejectWithValue },
  ) => {
    const response = await updateRespondentCounselAPI(
      respondentCounselID,
      respondentCounselData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteRespondentCounselAction = createAsyncThunk(
  "respondentCounsel/deleteRespondentCounsel",
  async (respondentCounselID, { rejectWithValue }) => {
    const response = await deleteRespondentCounselAPI(respondentCounselID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteRespondentCounselDocumentAction = createAsyncThunk(
  "respondentCounsel/deleteRespondentCounselDocument",
  async ({ documentID }, { rejectWithValue }) => {
    const response = await deleteRespondentCounselDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
